import { OPPORTUNITY_EDITOR_STEPS } from "../../../store/admin/investorPortal/constants";

export default function AdminEditorStepper({ currentStep, onStepChange, completedSteps = [] }) {
  const maxReachable = Math.max(-1, ...completedSteps, -1) + 1;

  return (
    <nav className="admin-editor-stepper mb-0 flex-grow-1" aria-label="Editor steps">
      <div className="admin-editor-stepper-track">
        {OPPORTUNITY_EDITOR_STEPS.map((step, index) => {
          const isActive = index === currentStep;
          const isComplete = completedSteps.includes(index);
          const isReachable = index === currentStep || completedSteps.includes(index) || index <= maxReachable;
          return (
            <button
              key={step.key}
              type="button"
              className={`admin-editor-step${isActive ? " admin-editor-step--active" : ""}${
                isComplete ? " admin-editor-step--complete" : ""
              }${!isReachable ? " admin-editor-step--locked" : ""}`}
              onClick={() => {
                if (isReachable) onStepChange(index);
              }}
              disabled={!isReachable}
              aria-current={isActive ? "step" : undefined}
              aria-disabled={!isReachable}
            >
              <span className="admin-editor-step-index">{isComplete && !isActive ? "✓" : index + 1}</span>
              <span className="admin-editor-step-label">{step.label}</span>
            </button>
          );
        })}
      </div>
      <p className="admin-editor-stepper-mobile-label d-md-none small text-muted mb-0 mt-2">
        Step {currentStep + 1} of {OPPORTUNITY_EDITOR_STEPS.length}:{" "}
        {OPPORTUNITY_EDITOR_STEPS[currentStep]?.label}
      </p>
    </nav>
  );
}
